import React from "react";
import Sidebar from "react-sidebar";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import 'rc-time-picker/assets/index.css';
import ControlledTabs from './ControlledTabs.js'
import SettingsElement from './SettingsElement.js'
import store from "./store/index";
import { updateSettingChanged, updateTimeSettings } from "./actions/index";
import { updateT0Settings } from "./actions/index";
import momentz from 'moment-timezone';
import CheckBox from './checkBoxComponent.js'
import { RadioGroup, RadioButton } from 'react-radio-buttons';
import TimeSetter from './timeSetter.js'
import TimeSetterT0 from './timeSetter_t0.js'
import TimeSetterLatestOdds from './TimeSetterLatestOdds.js'
import  { Redirect } from 'react-router-dom'
import { Auth } from "aws-amplify";
import {STEAMER_MIN_PRICE} from "./constants/action-types";
import {STEAMER_MAX_PRICE} from "./constants/action-types";
import {DRIFTER_MIN_PRICE} from "./constants/action-types";
import {DRIFTER_MAX_PRICE} from "./constants/action-types";
import {MIN_VOLUME} from "./constants/action-types";
import {updateLocalTimeOffSetToGmt} from "./actions/index";
import {updateLocalTimeZone} from "./actions/index";
import "./index.css";
import { updateTimeSettingsOneByOne } from "./actions/index";
import { updateFilteredCountryList } from "./actions/index";
import { updateExactTimeSettingsOneByOne } from "./actions/index";
import {update_Is_Exact_Time_One_By_One} from "./actions/index";
import {update_Steamer_Drifter_Settings} from "./actions/index";
import {updateLatestOddsSettings} from "./actions/index";
import { updateBackStakeSetting, updateCommissionSetting, updateLayStakeSetting } from "./actions/index";



const showSecond = false;
const str = showSecond ? 'HH:mm:ss' : 'HH:mm';

const inlineBlock = {
  display:'inline-block',
  width:'50%',
  color:'white',
}

const textColor1 = {
  color: 'green',

}

const style34 = {
  width:'300px',
  margin: '0 auto'
}
const format = 'hh:mm';

const ttt23={
  textAlign: 'center'
}

function minutesToHHMM(mins) {
  if(mins<0){
    return '00:00'
  }
let h = Math.floor(mins / 60);
let m = mins % 60;
  m = m < 10 ? '0' + m : m;
  h = h < 10 ? '0' + h : h;
  return `${h}:${m}`;
}


const alignCenter2={
  color: 'white',
  align: 'center',
  fontWeight: 'bold',
  margin: '0 auto'
}

const margin23={
  height: '50px',
  background: 'black'
}

const margin24={
  //marginTop: '20px',
  //marginBottom: '20px',
  bottom: '0',
  background: 'black'
}

const sideBarStyle = {
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: "hidden",
  },
  sidebar: {
    zIndex: 2,
    position: "absolute",
    top: 0,
    bottom: 0,
    transition: "left transform .3s ease-out",
    WebkitTransition: "-webkit-transform .3s ease-out",
    willChange: "transform",
    overflowY: "auto",
    background: "gray",
    width:"400px",
  },
  content: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    transition: "left .3s ease-out, right .3s ease-out"
  },
  overlay: {
    zIndex: 1,
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0,
    visibility: "hidden",
    transition: "opacity .3s ease-out, visibility .3s ease-out",
    backgroundColor: "rgba(0,0,0,.3)"
  },
  dragHandle: {
    zIndex: 1,
    position: "fixed",
    top: 0,
    bottom: 0
  }
};

const timeArray = {
  t1: "03:30",
  t2: "06:45",
  t3: "07:00",
  t4: "34:30",
  t5: "02:00",
  t6: "03:00"
}

const btnMargin = {
  'margin-top': '10px',
}

class AppSideBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      isAuthenticated: false
    };
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);

  }

  componentDidMount(){
    const offset = new Date().getTimezoneOffset() * -1;
    const timezone = this.convertMinutesToLocalTimeZone(offset);
    //console.log("timezone offset: " + offset + ", timezone: " + timezone);
    store.dispatch(updateLocalTimeOffSetToGmt(offset));
    store.dispatch(updateLocalTimeZone(timezone));
  }

  convertMinutesToLocalTimeZone = num => {
    let sign = "+";
    if (num < 0) sign = "-"
    num = Math.abs(num);
    const hours = Math.floor(num / 60);
    const minutes = num % 60;
    return "GMT" + sign + (hours < 10 ? "0" + hours : hours) + ":" + (minutes < 10 ? "0" + minutes : minutes);
  }


  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }

  getTimeDiffInMins(timeDiff){
    var hours =parseInt(timeDiff.substring(0,2))
    var mints =parseInt(timeDiff.substring(3,5))

    return (hours*60+mints)

  }



  handleSubmit(event) {
    //alert('A name was submitted: ' + timeArray );
    store.dispatch( updateTimeSettings(timeArray))
    //console.log('A name was submitted: ' + timeArray.t2);
    event.preventDefault();
  }

  handleChange(value,event) {
    //console.log(" On change ->  "+(value && value.format(str)));
  }

  renderRedirect = () => {
     if (!this.props.isAuthenticated) {
       return <Redirect to='/login' />
     }
   }

   handleSubmit = async event =>{
     //console.log("Submit button clicked");

     try {
      const user = await Auth.currentAuthenticatedUser();
      await Auth.updateUserAttributes(user, {
      "custom:t1": store.getState().timeSettings.t1,
      "custom:t2": store.getState().timeSettings.t2,
      "custom:t3": store.getState().timeSettings.t3,
      "custom:t4": store.getState().timeSettings.t4,
      "custom:t5": store.getState().timeSettings.t5,
      "custom:t6": store.getState().timeSettings.t6,
      "custom:t0": [store.getState().timeSettings.t0gb,store.getState().timeSettings.t0anz,store.getState().timeSettings.t0oth,].toString()  +
      "|" + store.getState().latestOddsSettings.commision +
      "|" + store.getState().latestOddsSettings.backStake +
      "|" + store.getState().latestOddsSettings.layStake,
      "custom:exact_t1":store.getState().exactTimeSettings.t1,
      "custom:exact_t2":store.getState().exactTimeSettings.t2,
      "custom:exact_t3":store.getState().exactTimeSettings.t3,
      "custom:exact_t4":store.getState().exactTimeSettings.t4,
      "custom:exact_t5":store.getState().exactTimeSettings.t5,
      "custom:exact_t6":store.getState().exactTimeSettings.t6,
      "custom:exact_t0":[store.getState().exactTimeSettings.t0gb, store.getState().exactTimeSettings.t0anz, store.getState().exactTimeSettings.t0oth].toString(), 
      "custom:t1_type":store.getState().isExactTimeSelected.t1,
      "custom:t2_type":store.getState().isExactTimeSelected.t2,
      "custom:t3_type":store.getState().isExactTimeSelected.t3,
      "custom:t4_type":store.getState().isExactTimeSelected.t4,
      "custom:t5_type":store.getState().isExactTimeSelected.t5,
      "custom:t6_type":store.getState().isExactTimeSelected.t6,
      "custom:t0_type":[store.getState().isExactTimeSelected.t0gb, store.getState().isExactTimeSelected.t0anz, store.getState().isExactTimeSelected.t0oth].toString(),
      "custom:steamer_min_price":store.getState().StearmerDrifterSettings.STEAMER_MIN_PRICE,
      "custom:steamer_max_price":store.getState().StearmerDrifterSettings.STEAMER_MAX_PRICE,
      "custom:drifter_min_price":store.getState().StearmerDrifterSettings.DRIFTER_MIN_PRICE,
      "custom:drifter_max_price":store.getState().StearmerDrifterSettings.DRIFTER_MAX_PRICE,
      "custom:min_volume":store.getState().StearmerDrifterSettings.MIN_VOLUME,
      "custom:filteredCountryList": store.getState().filteredCountryList.toString(),
      "custom:latestodds:mode":store.getState().latestOddsSettings.tickUntilActualStart,
      "custom:latestodds:seconds":store.getState().latestOddsSettings.noOfSeconds
      });
      alert("Successfully Updated");
      //window.location.reload();
      this.loadDetails();
    } catch (e) {
      alert(e.message);
      console.log(e);
    }
   }

   async loadDetails(){
     try {
     const info = await Auth.currentUserInfo()
     //console.log('Returned info:: ', info)
     let filteredCountryList = info.attributes["custom:filteredCountryList"]
     var Arr = filteredCountryList.split(',');
     store.dispatch(updateFilteredCountryList(Arr))
     //console.log('Returned info Array :: ', Arr)
   
     let payload={}
     payload.id = "t1"
     payload.value = info.attributes["custom:t1"]
     store.dispatch(updateTimeSettingsOneByOne(payload))
   
     payload.id = "t2"
     payload.value = info.attributes["custom:t2"]
     store.dispatch( updateTimeSettingsOneByOne(payload))
   
     payload.id = "t3"
     payload.value = info.attributes["custom:t3"]
     store.dispatch( updateTimeSettingsOneByOne(payload))
   
     payload.id = "t4"
     payload.value = info.attributes["custom:t4"]
     store.dispatch( updateTimeSettingsOneByOne(payload))
   
     payload.id = "t5"
     payload.value = info.attributes["custom:t5"]
     store.dispatch( updateTimeSettingsOneByOne(payload))
   
     payload.id = "t6"
     payload.value = info.attributes["custom:t6"]
     store.dispatch( updateTimeSettingsOneByOne(payload))
   
     let customT0Diff = (info.attributes["custom:t0"].split("|")[0]).split(",")
     if(customT0Diff.length > 0 ){
       payload.id = "t0gb"
       payload.value = customT0Diff[0]
       store.dispatch(updateTimeSettingsOneByOne(payload))
     }
     if(customT0Diff.length > 1){
       payload.id = "t0anz"
       payload.value = customT0Diff[1]
       store.dispatch(updateTimeSettingsOneByOne(payload))
     }
     if(customT0Diff.length > 2){
       payload.id = "t0oth"
       payload.value = customT0Diff[2]
       store.dispatch(updateTimeSettingsOneByOne(payload))
     }
     
   
     payload.id = "diffgb"
     payload.value = customT0Diff[0];    
     store.dispatch( updateT0Settings(payload))
    
     payload.id = "diffanz"
     payload.value = customT0Diff[1];    
     store.dispatch( updateT0Settings(payload))
    
     payload.id = "diffoth"
     payload.value = customT0Diff[2];    
     store.dispatch( updateT0Settings(payload))
    
   
     payload.id = "commision"
     payload.value = info.attributes["custom:t0"].split("|")[1]
     store.dispatch(updateCommissionSetting(payload))
   
     payload.id = "backStake"
     payload.value = info.attributes["custom:t0"].split("|")[2]
     store.dispatch(updateBackStakeSetting(payload))
   
     payload.id = "layStake"
     payload.value = info.attributes["custom:t0"].split("|")[3]
     store.dispatch(updateLayStakeSetting(payload))
   
     payload.id = "t1"
     payload.value = info.attributes["custom:exact_t1"]
     store.dispatch(updateExactTimeSettingsOneByOne(payload))
   
     payload.id = "t2"
     payload.value = info.attributes["custom:exact_t2"]
     store.dispatch( updateExactTimeSettingsOneByOne(payload))
   
     payload.id = "t3"
     payload.value = info.attributes["custom:exact_t3"]
     store.dispatch( updateExactTimeSettingsOneByOne(payload))
   
     payload.id = "t4"
     payload.value = info.attributes["custom:exact_t4"]
     store.dispatch( updateExactTimeSettingsOneByOne(payload))
   
     payload.id = "t5"
     payload.value = info.attributes["custom:exact_t5"]
     store.dispatch( updateExactTimeSettingsOneByOne(payload))
   
     payload.id = "t6"
     payload.value = info.attributes["custom:exact_t6"]
     store.dispatch( updateExactTimeSettingsOneByOne(payload))
   
     let exact_t0 = info.attributes["custom:exact_t0"].split(",")
     if(exact_t0.length > 0){
       payload.id = "t0gb"
       payload.value = exact_t0[0]
       store.dispatch(updateExactTimeSettingsOneByOne(payload))
     }
     if(exact_t0.length > 1){
       payload.id = "t0anz"
       payload.value = exact_t0[1]
       store.dispatch(updateExactTimeSettingsOneByOne(payload))
     }
     if(exact_t0.length > 2){
       payload.id = "t0oth"
       payload.value = exact_t0[2]
       store.dispatch(updateExactTimeSettingsOneByOne(payload))
     }
   
     payload.id = "t1"
     payload.value = info.attributes["custom:t1_type"]
     store.dispatch( update_Is_Exact_Time_One_By_One(payload))
     payload.id = "t2"
     payload.value = info.attributes["custom:t2_type"]
     store.dispatch( update_Is_Exact_Time_One_By_One(payload))
     payload.id = "t3"
     payload.value = info.attributes["custom:t3_type"]
     store.dispatch( update_Is_Exact_Time_One_By_One(payload))
     payload.id = "t4"
     payload.value = info.attributes["custom:t4_type"]
     store.dispatch( update_Is_Exact_Time_One_By_One(payload))
     payload.id = "t5"
     payload.value = info.attributes["custom:t5_type"]
     store.dispatch( update_Is_Exact_Time_One_By_One(payload))
     payload.id = "t6"
     payload.value = info.attributes["custom:t6_type"]
     store.dispatch( update_Is_Exact_Time_One_By_One(payload))
     
     payload.id = "t0gb"
     let t0_types = info.attributes["custom:t0_type"].split(",");
     if(t0_types.length > 0){
       payload.value = t0_types[0]
       store.dispatch( update_Is_Exact_Time_One_By_One(payload))
     }
     if(t0_types.length > 1){
       payload.id = "t0anz"
       payload.value = t0_types[1]
       store.dispatch( update_Is_Exact_Time_One_By_One(payload))
     }
     if(t0_types.length > 2){
       payload.id = "t0oth"
       payload.value = t0_types[2]
       store.dispatch( update_Is_Exact_Time_One_By_One(payload))
     }
   
     if(t0_types.length > 0){
       payload.id = "optiongb"
       payload.value = t0_types[0]
       store.dispatch( updateT0Settings(payload))
     }
     if(t0_types.length > 1){
       payload.id = "optionanz"
       payload.value = t0_types[1]
       store.dispatch( updateT0Settings(payload))
     }
     if(t0_types.length > 2){
       payload.id = "optionoth"
       payload.value = t0_types[2]
       store.dispatch( updateT0Settings(payload))
     }
   
     payload.id = "tickUntilActualStart"
     payload.value = info.attributes["custom:latestodds:mode"]
     store.dispatch(updateLatestOddsSettings(payload))
   
     payload.id = "noOfSeconds"
     payload.value = info.attributes["custom:latestodds:seconds"]
     store.dispatch(updateLatestOddsSettings(payload))
   
   
     //Steamer Drifter Settings
     payload.id = "STEAMER_MIN_PRICE"
     payload.value = info.attributes["custom:steamer_min_price"]
     store.dispatch( update_Steamer_Drifter_Settings(payload))
     payload.id = "STEAMER_MAX_PRICE"
     payload.value = info.attributes["custom:steamer_max_price"]
     store.dispatch( update_Steamer_Drifter_Settings(payload))
     payload.id = "DRIFTER_MIN_PRICE"
     payload.value = info.attributes["custom:drifter_min_price"]
     store.dispatch( update_Steamer_Drifter_Settings(payload))
     payload.id = "DRIFTER_MAX_PRICE"
     payload.value = info.attributes["custom:drifter_max_price"]
     store.dispatch( update_Steamer_Drifter_Settings(payload))
     payload.id = "MIN_VOLUME"
     payload.value = info.attributes["custom:min_volume"]
     store.dispatch( update_Steamer_Drifter_Settings(payload))
   
     const offset = new Date().getTimezoneOffset() * -1;
     const timezone = this.convertMinutesToLocalTimeZone(offset);
     //console.log("timezone offset: " + offset + ", timezone: " + timezone);
     store.dispatch(updateLocalTimeOffSetToGmt(offset));
     store.dispatch(updateLocalTimeZone(timezone));
     store.dispatch(updateSettingChanged(Date.now()));
     }catch (e) {
      console.log("Error");
     //alert(e.message);
     }
     //this.setRedirect()
     //window.location.reload()
   }

  handleCheckboxChange = event =>
      this.setState({ checked: event.target.checked })

  render() {
    var stateVal = { checked: false }

    store.getState().allCountryList.map(country =>
    console.log("All Selected country ::"+country))



    console.log("hgjhnkjh kjk : "+store.getState().StearmerDrifterSettings.STEAMER_MIN_PRICE)
    return (
      <Sidebar
        sidebar={
          <div>
            {this.renderRedirect()}
          <div style={margin23} className="navbar navbar-dark bg-dark">
          <p style={alignCenter2}>Country Configuration</p>
          </div>
          <div>
            {Object.keys(store.getState().allCountryList2).map(countryItem =>
              <div key={countryItem} style={style34}><CheckBox country={store.getState().allCountryList2[countryItem]} /></div>
            )}
          </div>
          <div style={margin23} className="navbar navbar-dark bg-dark">
          <p style={alignCenter2}>Display Timezone - {store.getState().localTimeZone}</p>
          </div>
          <div className="formMargin">
          <Form  onSubmit={this.handleSubmit}>
          <TimeSetterLatestOdds />
          <hr/>
          <TimeSetter timeDiff={store.getState().timeSettings.t1} label="T1"/>
          <TimeSetter timeDiff={store.getState().timeSettings.t2} label="T2"/>
          <TimeSetter timeDiff={store.getState().timeSettings.t3} label="T3"/>
          <TimeSetter timeDiff={store.getState().timeSettings.t4} label="T4"/>
          <TimeSetter timeDiff={store.getState().timeSettings.t5} label="T5"/>
          <TimeSetter timeDiff={store.getState().timeSettings.t6} label="T6"/>
          <hr/>
          <div style={ttt23}><span style={alignCenter2}>Steamers/Drifters Options:</span></div>
          <TimeSetter timeDiff={store.getState().timeSettings.t0GB} label="t0gb"/>
          <TimeSetter timeDiff={store.getState().timeSettings.t0ANZ} label="t0anz"/>
          <TimeSetter timeDiff={store.getState().timeSettings.t0OTH} label="t0oth"/>
          <SettingsElement label="Steamers price(MIN)" fieldType="float" pattern="^\d*(\.\d{0,2})?$" step="0.05" value={store.getState().StearmerDrifterSettings.STEAMER_MIN_PRICE} id={STEAMER_MIN_PRICE}/>
          <SettingsElement label="Steamers price(MAX)" fieldType="float" pattern="^\d*(\.\d{0,2})?$" step="0.05" value={store.getState().StearmerDrifterSettings.STEAMER_MAX_PRICE} id={STEAMER_MAX_PRICE}/>
          <SettingsElement label="Drifters price(MIN)" fieldType="float" pattern="^\d*(\.\d{0,2})?$" step="0.05" value={store.getState().StearmerDrifterSettings.DRIFTER_MIN_PRICE} id={DRIFTER_MIN_PRICE}/>
          <SettingsElement label="Drifters price(MAX)" fieldType="float" pattern="^\d*(\.\d{0,2})?$" step="0.05" value={store.getState().StearmerDrifterSettings.DRIFTER_MAX_PRICE} id={DRIFTER_MAX_PRICE}/>
          <SettingsElement label="Minimum Volume" fieldType="integer" pattern="[0-9]" step="100" value={store.getState().StearmerDrifterSettings.MIN_VOLUME} id={MIN_VOLUME}/>
          <div className="wrapper1">
          <Button variant="secondary" block onClick={this.handleSubmit}>
          Submit
          </Button>
            </div>
        </Form>
        </div>
        </div>
        }
        open={this.state.sidebarOpen}
        onSetOpen={this.onSetSidebarOpen}
        styles={sideBarStyle}
      >
        <ControlledTabs openSideBar={this.onSetSidebarOpen} user={this.props.userName} userHasAuthenticated={this.props.userHasAuthenticated}/>


      </Sidebar>
    );
  }
}

export default AppSideBar;
